import { useDateFnsLocale } from 'Core/i18n/Hooks/useTranslationExtensions';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConversationEnded as ConversationEndedEvent } from 'Types/Conversations/Events';
import styles from '../conversations.module.css';

interface ConversationEndedProps {
    event: ConversationEndedEvent;
}

function ConversationEnded({ event }: ConversationEndedProps): React.ReactElement<ConversationEndedProps> {
    const { t } = useTranslation(['conversationsFeature']);
    const dateFnsLocale = useDateFnsLocale();
    // These two lines below are a "workaround" to localize `MM/dd/yy` dates
    // The closer equivalent in date-fns is to use `P`, but that renders a full year (yyyy)
    const rawLocalizedFormat = dateFnsLocale.formatLong?.date({
        width: 'short',
    });
    const fixedFormat = rawLocalizedFormat
        .replace(/(?<!d)d(?!d)/g, 'dd')
        .replace(/(?<!M)[M](?!M)/g, 'LL')
        .replace(/y{1,4}/g, 'yy');

    return (
        <div className={styles.SystemItem}>
            <p>
                <b>
                    {t('conversationsFeature:events.conversationEnded.title', {
                        date: format(new Date(event.metadata.eventDate), fixedFormat, {
                            locale: dateFnsLocale,
                        }),
                    })}
                </b>
            </p>
        </div>
    );
}

export default ConversationEnded;
